import React, { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  shouldHideNav,
  shouldFullyHideNav,
  noMobilePadding,
  isFundraisingCampaignPage,
  isOrganizationLandingPage,
  isPackagePurchasePage,
} from './utilities/helpers'

import { Navigation } from './components'

const ConditionalContainerNav = ({ children }) => {
  const location = useLocation()

  // control hide navigation
  useLayoutEffect(() => {
    const navbar = document.querySelector('#navbar')
    const mainContainer = document.querySelector('#main-container')
    const root = document.querySelector('#root')
    const isOrgLanding = isOrganizationLandingPage(location.pathname)
    const isPackagePage = isPackagePurchasePage(location.pathname)

    if (isOrgLanding) {
      document.documentElement.classList.add('organization-landing-page')
      document.body.classList.add('organization-landing-page')
      root?.classList.add('organization-landing-page')
    }

    if (isPackagePage) {
      document.documentElement.classList.add('package-purchase-page')
      document.body.classList.add('package-purchase-page')
      root?.classList.add('package-purchase-page')
    }

    if (
      navbar &&
      shouldHideNav(location.pathname) &&
      !shouldFullyHideNav(location.pathname)
    ) {
      // hide navbar on mobile
      navbar.classList.add('tablet-desktop-only')
    }

    if (mainContainer && noMobilePadding(location.pathname)) {
      // remove container padding on mobile
      mainContainer.classList.add('mobile-p0')
    }

    return () => {
      document.documentElement.classList.remove('organization-landing-page')
      document.body.classList.remove('organization-landing-page')
      root?.classList.remove('organization-landing-page')
      document.documentElement.classList.remove('package-purchase-page')
      document.body.classList.remove('package-purchase-page')
      root?.classList.remove('package-purchase-page')
      navbar?.classList.remove('tablet-desktop-only')
      mainContainer?.classList.remove('mobile-p0')
    }
  }, [location.pathname])

  const hideNavCompletely =
    shouldFullyHideNav(location.pathname) ||
    isFundraisingCampaignPage(location.pathname)

  const isPurchaseBleed =
    /\/e\/[^/]+\/[^/]+\/tickets/.test(location.pathname) ||
    /^\/e\/[^/]+\/[^/]+\/?$/.test(location.pathname)

  return (
    <>
      {!hideNavCompletely && <Navigation />}
      <div
        className={
          isOrganizationLandingPage(location.pathname)
            ? 'container-fluid p-0 container--organization-landing'
            : isPackagePurchasePage(location.pathname)
              ? 'container-fluid p-0 container--package-purchase'
              : isPurchaseBleed
                ? 'container-fluid p-0'
                : 'container'
        }
        id="main-container"
      >
        {children}
      </div>
    </>
  )
}

export default ConditionalContainerNav
